import React from 'react';

import { Flex, Td } from '@chakra-ui/react';

export const TableBodyCell = ({ children, flexContainerProps = {}, ...props }) => (
  <Td px={3} py={0} border={0} {...props}>
    <Flex h="56px" alignItems="center" {...flexContainerProps}>
      {children}
    </Flex>
  </Td>
);
